import { AlertCircle } from 'lucide-react';

// Inline error banner rendered at the top of a page. Distinct from `PageError`,
// which replaces the entire page with a full-page error when the initial fetch
// fails; `InlineError` sits above content that still rendered normally (e.g. a
// non-fatal fetch error or a form-level submit failure).
export function InlineError({ message, className = 'mb-6' }: { message: string; className?: string }) {
    return (
        <div className={`bg-state-error/10 border border-state-error/30 rounded-lg p-4 flex items-start gap-3${className ? ` ${className}` : ''}`}>
            <AlertCircle className="w-5 h-5 text-state-error shrink-0 mt-0.5" />
            <p className="text-sm text-state-error flex-1">{message}</p>
        </div>
    );
}
